import React from 'react';
// import ReactDOM from 'react-dom/client';
import ReactDOM from 'react-dom';
import './assets/index.css';
import App from './App';
// import reportWebVitals from './reportWebVitals';
import { Route, Routes } from 'react-router-dom';
import { BrowserRouter } from 'react-router-dom';


ReactDOM.render(
    <BrowserRouter>
    <App />
    </BrowserRouter>, document.getElementById('root'));